import styled from 'styled-components';
import { Paper } from '@mui/material';

export const Card = styled(Paper)`
    padding: 24px;
    box-shadow: 0px 3px 12px rgba(81, 69, 159, 0.08);
    overflow: hidden;
    height: 100%;
    > div {
        height: 100%;
        width: 100%;
        align-items: center;
        justify-content: center;
        > h1 {
            margin-top: ${({ margin }) => margin || '24px'};
            font-size: 42px;
            text-align: center;
            color: ${({ color }) => color || 'black'};
        }
        > div {
            display: flex;
            justify-content: center;
            align-items: flex-end;
            margin-top: 24px;
            gap: 5px;
            > h1 {
                line-height: 40px;
                font-size: 42px;
            }
            > p {
                line-height: 20px;
                font-size: 16px;
            }
        }
        > h2 {
            margin-top: 13px;
            line-height: 20px;
            font-size: 24px;
            text-align: center;
        }
        > p {
            line-height: 20px;
            font-size: 16px;
            text-align: center;
        }
    }
`;
